import { render, staticRenderFns } from "./assetsAdd.vue?vue&type=template&id=19b260d0&scoped=true&"
import script from "./assetsAdd.vue?vue&type=script&lang=js&"
export * from "./assetsAdd.vue?vue&type=script&lang=js&"
import style0 from "./assetsAdd.vue?vue&type=style&index=0&id=19b260d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b260d0",
  null
  
)

export default component.exports